import { z } from "zod";

export const createListBoxSchema = <T extends string>() =>
  z.object({
    id: z.number(),
    value: z.custom<T>(),
    label: z.string(),
  });
